<template>
  <el-dialog title="选择移动到" :visible.sync="moveInfo.show" width="550px">
    <el-tree
      v-if="!isGoSplit"
      :data="treeData"
      :props="defaultProps"
      @node-click="handleNodeClick"
      highlight-current
    ></el-tree>
    <div v-else class="text-center">
      <div>你还未创建小班</div>
      <div>
        去「小班管理」 <span class="bule-char" @click="toAdd">新增小班>></span>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeDia" title="取消"></butn>
      <butn btntype="primary" @click.native="confirm" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";

export default {
  components: {
    butn,
  },
  props: {
    moveInfo: {
      type: Object,
      default: () => {
        return {
          show: false,
        };
      },
    },
    treeData: {
      type: Array,
      default: () => [],
    },
    defaultProps: {
      type: Object,
      default: () => {
        return {
          children: "groupList",
          label: "paramValue",
        };
      },
    },
    isGoSplit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      nowNode: {},
    };
  },
  methods: {
    handleNodeClick(data, node) {
      if (node.level > 1) {
        this.nowNode = {
          newSmallClassId: node.parent.data.paramKey,
          newGroupId: data.paramKey,
        };
      } else {
        this.nowNode = { newSmallClassId: data.paramKey };
      }
    },
    closeDia() {
      this.$emit("closeMove");
    },
    confirm() {
      if (!this.isGoSplit) {
        this.$emit("sureMove", this.nowNode);
      } else {
        this.closeDia();
      }
    },
    toAdd() {
      this.$emit("goClassList");
    },
  },
};
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}

.bule-char {
  cursor: pointer;
  color: #3a8fca;
}
</style>
